module.exports = __webpack_public_path__ + "media/images/footer/facebook-207f6af3ffcb0cab6b8443198bbdcc92.svg";